import { FunnelWebsiteRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { Modules } from '../../util/modules'
import { requireAuthAndLocation } from '../auth'

const clientPortalBuilder = () =>
  import('@/pmd/pages/client-portal/ClientPortalMicroApp.vue')
const FunnelRoot = () =>
  import('@/pmd/pages/funnels/FunnelRoot.vue').then(m => m.default)
const FunnelsPage = () =>
  import('@/pmd/pages/funnels/FunnelsPage.vue').then(m => m.default)
const WebsitesPage = () =>
  import('@/pmd/pages/funnels/WebsitesPage.vue').then(m => m.default)
const StoresPage = () =>
import('@/pmd/pages/funnels/StoresPage.vue').then(m => m.default)
const WebinarsPage = () =>
  import('@/pmd/pages/funnels/WebinarsPage.vue').then(m => m.default)

const ChatWidgetBuilder = () => import('../../pmd/pages/chat_widget/Builder.vue').then(m => m.default)

const ChatWidgetList = () => import('../../pmd/pages/chat_widget/List.vue').then(m => m.default)

const FunnelDetailPage = () =>
  import(
    /* webpackChunkName: "funnel-details" */ '@/pmd/pages/funnels/FunnelDetailPage.vue'
  )
const WordpressAppIndexPage = () =>
  import(
    /* webpackChunkName: "wordpress-dashboard" */ '@/pmd/pages/wordpress/WordpressAppIndexPage.vue'
  )

export const FunnelWebsiteRoute: RouteConfig[] = [
  {
    path: 'funnels-websites/client-portal',
    component: clientPortalBuilder,
    children: [
      {
        path: 'dashboard',
        name: FunnelWebsiteRouteNames.clientPortal.dashboard,
        component: clientPortalBuilder,
      },
      {
        path: 'domain-setup',
        name: FunnelWebsiteRouteNames.clientPortal.domainSetup,
        component: clientPortalBuilder,
      },
      {
        path: 'branding',
        name: FunnelWebsiteRouteNames.clientPortal.branding,
        component: clientPortalBuilder,
      },
      {
        path: 'branded-app',
        name: FunnelWebsiteRouteNames.clientPortal.brandedApp,
        component: clientPortalBuilder,
      },
      {
        path: 'app-permission',
        name: FunnelWebsiteRouteNames.clientPortal.appPermission,
        component: clientPortalBuilder,
      },
      {
        path: 'settings',
        name: FunnelWebsiteRouteNames.clientPortal.settings,
        component: clientPortalBuilder,
      },
      {
        path: 'email-settings',
        name: FunnelWebsiteRouteNames.clientPortal.emailSettings,
        component: clientPortalBuilder,
      },
      {
        path: 'language-settings',
        name: FunnelWebsiteRouteNames.clientPortal.languageSettings,
        component: clientPortalBuilder,
      },
      {
        path: 'chat-widget-settings',
        name: FunnelWebsiteRouteNames.clientPortal.chatWidget,
        component: clientPortalBuilder,
      },
    ],
  },
  {
    path: 'funnels-websites',
    name: FunnelWebsiteRouteNames.funnels.default,
    component: FunnelRoot,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'funnels',
        name: FunnelWebsiteRouteNames.funnels.funnelsPage,
        component: FunnelsPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'websites',
        name: FunnelWebsiteRouteNames.funnels.funnelsWebsite,
        component: WebsitesPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'stores',
        name: FunnelWebsiteRouteNames.funnels.funnelsStore,
        component: StoresPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'webinars',
        name: FunnelWebsiteRouteNames.funnels.funnelsWebinar,
        component: WebinarsPage,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'funnels-websites/funnels/:funnel_id',
    name: FunnelWebsiteRouteNames.funnelsDetails.default,
    component: FunnelDetailPage,
    // Child route components are handled in micro frontend app
    children: [
      {
        path: 'steps/:step_id?',
        name: FunnelWebsiteRouteNames.funnelsDetails.steps,
        children: [
          {
            path: 'overview',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepOverview,
          },
          {
            path: 'publish',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepPublish,
          },
          {
            path: 'product',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepProduct,
          },
          {
            path: 'products',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepProducts,
          },
          {
            path: 'products/create',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepProductCreate,
          },
          {
            path: 'products/:funnel_product_id',
            name: FunnelWebsiteRouteNames.funnelsDetails.stepProductEdit,
          },
        ],
      },
      {
        path: 'stats',
        name: FunnelWebsiteRouteNames.funnelsDetails.stats,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'sales',
        name: FunnelWebsiteRouteNames.funnelsDetails.sales,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'settings',
        name: FunnelWebsiteRouteNames.funnelsDetails.settings,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'security',
        name: FunnelWebsiteRouteNames.funnelsDetails.security,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'events',
        name: FunnelWebsiteRouteNames.funnelsDetails.events,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
  {
    path: 'funnels-websites/websites/:funnel_id',
    name: FunnelWebsiteRouteNames.funnelWebsites.default,
    component: FunnelDetailPage,
    children: [
      {
        path: 'pages/:step_id?',
        name: FunnelWebsiteRouteNames.funnelWebsites.pages,
      },
      {
        path: 'stats',
        name: FunnelWebsiteRouteNames.funnelWebsites.stats,
      },
      {
        path: 'sales',
        name: FunnelWebsiteRouteNames.funnelWebsites.sales,
      },
      {
        path: 'settings',
        name: FunnelWebsiteRouteNames.funnelWebsites.settings,
      },
      {
        path: 'security',
        name: FunnelWebsiteRouteNames.funnelWebsites.security,
      },
      {
        path: 'events',
        name: FunnelWebsiteRouteNames.funnelWebsites.events,
      },
      {
        path: 'products/:step_id',
        name: FunnelWebsiteRouteNames.funnelWebsites.products,
      },
      {
        path: 'website-products/:step_id',
        name: FunnelWebsiteRouteNames.funnelWebsites.stepProduct,
      },
      {
        path: 'products/create',
        name: FunnelWebsiteRouteNames.funnelWebsites.stepProductCreate,
      },
      {
        path: 'products/:funnel_product_id',
        name: FunnelWebsiteRouteNames.funnelWebsites.stepProductEdit,
      },
    ],
  },
  {
    path: 'funnels-websites/stores/:funnel_id',
    name: FunnelWebsiteRouteNames.funnelStores.default,
    component: FunnelDetailPage,
    children: [
      {
        path: 'pages/:step_id?',
        name:  FunnelWebsiteRouteNames.funnelStores.pages,
      },
      {
        path: 'stats',
        name: FunnelWebsiteRouteNames.funnelStores.stats,
      },
      {
        path: 'product-select',
        name: FunnelWebsiteRouteNames.funnelStores.productSelect,
      },
      {
        path: 'sales',
        name: FunnelWebsiteRouteNames.funnelStores.sales,
      },
      {
        path: 'settings',
        name: FunnelWebsiteRouteNames.funnelStores.settings,
      },
      {
        path: 'security',
        name: FunnelWebsiteRouteNames.funnelStores.security,
      },
      {
        path:'events',
        name: FunnelWebsiteRouteNames.funnelStores.events,
      },
      {
        path: 'products/:step_id',
        name: FunnelWebsiteRouteNames.funnelStores.products,
      },
      {
        path: 'store-products/:step_id',
        name: FunnelWebsiteRouteNames.funnelStores.stepProduct,
      },
      {
        path: 'products/create',
        name: FunnelWebsiteRouteNames.funnelStores.stepProductCreate,
      },
      {
        path: 'products/:funnel_product_id',
        name: FunnelWebsiteRouteNames.funnelStores.stepProductEdit,
      },
    ],
  },
  {
    path: 'funnels-websites/webinars/:funnel_id',
    name: FunnelWebsiteRouteNames.webinars.default,
    component: FunnelDetailPage,
    children: [
      {
        path: 'pages/:step_id?',
        name:  FunnelWebsiteRouteNames.webinars.pages,
      },
      {
        path: 'stats',
        name: FunnelWebsiteRouteNames.webinars.stats,
      },
      {
        path: 'sales',
        name: FunnelWebsiteRouteNames.webinars.sales,
      },
      {
        path: 'settings',
        name: FunnelWebsiteRouteNames.webinars.settings,
      },
      {
        path: 'security',
        name: FunnelWebsiteRouteNames.webinars.security,
      },
      {
        path:'events',
        name: FunnelWebsiteRouteNames.webinars.events,
      },
      {
        path: 'products/:step_id',
        name: FunnelWebsiteRouteNames.webinars.products,
      },
      {
        path: 'store-products/:step_id',
        name: FunnelWebsiteRouteNames.webinars.stepProduct,
      },
      {
        path: 'products/create',
        name: FunnelWebsiteRouteNames.webinars.stepProductCreate,
      },
      {
        path: 'products/:funnel_product_id',
        name: FunnelWebsiteRouteNames.webinars.stepProductEdit,
      },
    ],
  },
  {
    path: 'funnels-websites/wordpress',
    redirect: 'wordpress',
  },
  {
    path: 'funnels-websites/wordpress/*',
    redirect: 'wordpress',        
  },
  {
    path: 'funnels-websites/chat_widget_settings',
    name: FunnelWebsiteRouteNames.chatWidgetSettings,
    component: ChatWidgetList,
    beforeEnter: requireAuthAndLocation,
    redirect: {path: "funnels-websites/chat-widget"}
  },
  {
    path: 'funnels-websites/chat-widget',
    name: FunnelWebsiteRouteNames.chatWidget,
    component: ChatWidgetList,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'funnels-websites/chat-widget/:widgetId',
    name: FunnelWebsiteRouteNames.editChatWidget,
    beforeEnter: requireAuthAndLocation,
    meta: { translations: [Modules.ChatWidgetBuilder] },
    redirect: {path :"funnels-websites/chat-widget/builder/:widgetId"}
  },
  {
    path:'funnels-websites/chat-widget/builder/:widgetId',
    name: 'chat-widget-builder',
    component: ChatWidgetBuilder,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true
    },
  },
]
